import { useState } from 'react';
import styles from './styles.module.css';
import Head from 'next/head';
import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import BannerCaja from '@/widgets/Banner/Templates/BannerCaja';
import DatePicker from '@/shared/components/DatePicker';
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import BannerHorizontalGrande from '@/widgets/Banner/Templates/BannerHorizontalGrande';
import Chartbeat from '@/shared/components/Chartbeat';

const Necrologicas = (props) => {
    const {
        properties
    } = { ...props };

    const stringDate = properties.date;

    const stringYear = stringDate.substr(0, 4);
    const stringMonth = stringDate.substr(4, 2);
    const stringDay = stringDate.substr(6, 2);

    let menues = props.menu ? props.menu : []; 
    const [open, setOpen] = useState(false);

    function pickDateAction(dayObject) {
        if (typeof window !== 'undefined') {
            const pickedYear = ("0000" + dayObject.year).slice(-4);
            const pickedMonth = ("0" + dayObject.month).slice(-2);
            const pickedDay = ("0" + dayObject.day).slice(-2);  
        const selectedDate = new Date(`${pickedYear}-${pickedMonth}-${pickedDay}`);
        const comparisonDate = new Date("2025-01-20");
            if (selectedDate < comparisonDate) {
            // Redirigir al enlace anterior a 20/01/2025
            window.location.href = `/index.php/diarios/${pickedYear}/${pickedMonth}/${pickedDay}/necrologicas/index.html`;
            } else {
            // Redirigir al enlace posterior a 20/01/2025
            window.location.href = `https://funebres.ellitoral.com/Busqueda?name=&date=${pickedYear}-${pickedMonth}-${pickedDay}`;
            }
   }
    }
    let dataLDJson =  {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
        "logo": {
          "@type": "ImageObject",
          "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
          "width": 439,
          "height": 60
        },
        "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
      };
    return (
        <>
            <Head>
                <title>Necrologicas Edición Impresa - El Litoral</title>
                <meta name="description" property="description" content="Necrologicas Edición Impresa - El Litoral. Noticias actualizadas las 24 horas." />
                <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
				<meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />  
                <meta httpEquiv="refresh" content="600" />
            </Head>
            <Chartbeat />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
            <div className={`${styles['main-container']}`}>
                <div className={`${styles['main-content']}`}>
                    <div className={`${styles['detail-left']}`}>
                        {!props.preview && <BannerHorizontalChico bannerId={'top'}/>}
                        <h2 className={`${styles['title']}`}>Necrológicas | Avisos Fúnebres | Ediciones Anteriores</h2>
                        <div className={`${styles['picker-container']}`}>
                            <DatePicker
                                selectedYear={parseInt(stringYear)}
                                selectedMonth={parseInt(stringMonth)}
                                selectedDay={parseInt(stringDay)}
                                pickDateAction={pickDateAction}
                                minYear={2000}
                            />
                        </div>
                    </div>
                    <div className={`${styles['detail-right']}`}>
                        <BannerCaja id={'caja-1'} />
                    </div>
                </div>
                {!props.preview && <BannerHorizontalChico bannerId={'horizontal1'}/>}
            </div>
            <div style={{ clear: 'both' }}>
                <Footer />
            </div>
        </>
    )
}

export default Necrologicas;
